module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/feature-1-image.webp?8f70f8cd";